import React, { FC } from 'react';
import { usePublicFeedbackState } from '../../../providers/PublicFeedback';
import { translations } from '../strings';
import { XCircle } from 'lucide-react';
import { Button } from 'antd';
import styles from './index.module.css';

type Props = {};

const PublicError: FC<Props> = () => {
  const { locale, setFeedbackState } = usePublicFeedbackState();
  const strings = translations(locale);

  return (
    <div className={styles.messageOuter}>
      <XCircle className={styles.errorIcon} />
      <p className={styles.moreInfoMessage}>{strings.error_message}</p>
      <div className={styles.actionsContainer}>
        <Button type="primary" onClick={() => setFeedbackState('TASK')}>
          {strings.try_again}
        </Button>
      </div>
    </div>
  );
};

export default PublicError;
